import { useEffect, useMemo, useState } from "react";
// INTERFACES
import { BankInterface } from "../../../interfaces/Bank.interface";
import { bankHasDoorSide, DoorSide } from "./terminalCommandSpecs";

interface FrontRearDoorAvailability {
  hasFront: boolean;
  hasRear: boolean;
  door: DoorSide;
  setDoor: (door: DoorSide) => void;
}

/**
 * Owns the front/rear door selection for a bank. Computes whether each side is
 * available at all and snaps the current selection if the user picks a side
 * the bank does not actually have (e.g. picks Rear on a front-only bank).
 */
export default function useFrontRearDoorAvailability(
  bank: BankInterface,
): FrontRearDoorAvailability {
  const [door, setDoor] = useState<DoorSide>("FRONT");
  const hasFront = useMemo(() => bankHasDoorSide(bank, "FRONT"), [bank]);
  const hasRear = useMemo(() => bankHasDoorSide(bank, "REAR"), [bank]);

  useEffect(() => {
    if (door === "REAR" && !hasRear) setDoor("FRONT");
    if (door === "FRONT" && !hasFront && hasRear) setDoor("REAR");
  }, [door, hasFront, hasRear]);

  return { hasFront, hasRear, door, setDoor };
}
